module.exports = __webpack_public_path__ + "img/icon4.712a4ae7.png";